import { CommonModule } from "@angular/common";
import { ChangeDetectorRef, Component } from "@angular/core";
import { SharedModule } from "@shared/shared_module";
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from "@angular/router";
import { filter } from "rxjs";

@Component({
  selector: "app-permission-settings",
  imports: [CommonModule, SharedModule, RouterModule],
  templateUrl: "./permission-settings.component.html",
  styleUrl: "./permission-settings.component.scss",
  standalone: true,
})
export class PermissionSettingsComponent {
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}
  activeTab: "permissions" | "permission-groups" = "permissions";

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateActiveTabFromUrl();
      });

    this.updateActiveTabFromUrl();
  }

  private updateActiveTabFromUrl(): void {
    const urlSegments = this.router.url.split("/");
    const lastSegment = urlSegments[urlSegments.length - 1];

    if (lastSegment === "permissions") {
      this.activeTab = "permissions";
    } else if (lastSegment === "permission-groups") {
      this.activeTab = "permission-groups";
    } else {
      this.activeTab = "permissions";
      if (this.router.url === "/permission-Settings") {
        this.router.navigate(["./permissions"], {
          relativeTo: this.activatedRoute,
          replaceUrl: true,
        });
      }
    }
    this.cdr.detectChanges();
  }

  handleCreateUser() {}

  navigateToTab(tabName: "permissions" | "permission-groups"): void {
    this.router.navigate([`./${tabName}`], { relativeTo: this.activatedRoute });
  }
}
